import { Component, Input, OnInit } from '@angular/core';
import { UrlService } from '../../../miscellaneous/url.service';
import { LocalService } from 'src/app/services/local.service';

@Component({
  selector: 'tabs',
  templateUrl: './tabs.component.html',
  styleUrls: ['./tabs.component.scss'],
  providers: [UrlService],
})
export class TabsComponent implements OnInit {

  @Input() props!: any;
  @Input() fieldGroup!: any[];
  tabs: any[] = [];
  id: string | false = false;

  static compName = 'Tabs';

  constructor(private serUrl: UrlService, private localService: LocalService) { }

  ngOnInit(): void {
    let keysFromLocalService: any = this.localService.getAllKeys();
    this.id = this.serUrl.getUrlId(this.props['page']);
    this.fieldGroup.forEach(tab => {
      if (!(!this.id && tab.props['hidden'])) {
        this.tabs.push(tab);
      }
      if (tab.props['show']) {
        const objectFromJSON = tab.props['show'];
        const keyFromJSON = Object.keys(objectFromJSON)[0];
        const valueFromJSON = objectFromJSON[keyFromJSON];
        const isValueIncluded = valueFromJSON.includes(keysFromLocalService[keyFromJSON]);
        tab.disabled = !isValueIncluded;
      }
    })
  }

  setHref(i: number) {
    // @ts-ignore
    return (this.props['type'] === 'remote') ? '#' : ('#' + this.props['key'] + '-content' + (i + 1));
  }

  onClick(props: any) {
    let id = this.id ? '/' + this.id : null;
    if (props.urlpage) this.serUrl.goToPage('/' + props.urlpage + (id ? id : ""));
  }

}
